import { hero, company, ctaSection, statistics, targetAudiences, testimonials, processSteps } from './site';
import { projects } from './projects';
import { servicePages } from './services';
import images from './images';

const f = (key, label, type, group, page, defaultValue) => ({
  key, label, type, group, page, default: defaultValue,
});

const servicePageDefs = {
  '/mobilitaet': {
    slug: 'mobilitaet',
    label: 'Mobilität',
    heroLabel: 'Mobilität',
    heroTitle: 'Fahrzeugveredelung & Schutz',
    heroDesc: 'Von der Lackschutzfolie bis zum kompletten Flottenbranding – wir realisieren Ihre Fahrzeugprojekte mit Präzision und Premium-Qualität.',
    heroCtaLabel: 'Projekt anfragen',
    servicesLabel: 'Leistungen',
    servicesTitle: 'Leistungen im Überblick',
    projectsLabel: 'Referenzen',
    projectsTitle: 'Typische Projekte',
    projectsCtaLabel: 'Alle Projekte',
    faqLabel: 'Fragen',
    faqTitle: 'Häufig gefragt',
    ctaLabel: 'Jetzt starten',
    ctaTitle: 'Ihr Fahrzeugprojekt',
    ctaDesc: 'Ob Einzelfahrzeug oder Flotte – wir beraten Sie gerne zu den Möglichkeiten.',
    ctaButtonLabel: 'Kontakt aufnehmen',
    heroImage: images.servicePages['mobilitaet'],
    services: servicePages.mobilitaet?.services || [],
    faqs: servicePages.mobilitaet?.faqs || [],
  },
  '/architektur-raum': {
    slug: 'architektur',
    label: 'Raum & Architektur',
    heroLabel: 'Raum & Architektur',
    heroTitle: 'Markenräume und Oberflächen',
    heroDesc: 'Wir transformieren Räume in Markenerlebnisse – durch Architekturfolierung, Glasgestaltung und Interior Branding.',
    heroCtaLabel: 'Projekt anfragen',
    servicesLabel: 'Leistungen',
    servicesTitle: 'Unsere Kompetenzen',
    projectsLabel: 'Referenzen',
    projectsTitle: 'Ausgewählte Projekte',
    projectsCtaLabel: 'Alle Projekte',
    faqLabel: 'Fragen',
    faqTitle: 'Häufig gefragt',
    ctaLabel: 'Jetzt starten',
    ctaTitle: 'Ihr Raumprojekt',
    ctaDesc: 'Lassen Sie uns über Ihre Raumgestaltung sprechen – von der ersten Idee bis zur Umsetzung.',
    ctaButtonLabel: 'Kontakt aufnehmen',
    heroImage: images.servicePages['architektur-raum'],
    services: [
      { title: 'Raumgestaltung', desc: 'Ganzheitliche Konzepte für Ihre Markenräume' },
      { title: 'Architekturfolierung', desc: 'Oberflächenveredelung für Fassaden und Innenräume' },
      { title: 'Glas- & Sichtschutzfolien', desc: 'Funktionale und ästhetische Glaslösungen' },
      { title: 'Interior Branding', desc: 'Markenidentität in Ihren Räumen verankern' },
      { title: 'Oberflächenveredelung', desc: 'Premium-Finish für Möbel und Einbauten' },
      { title: 'Raumkonzepte', desc: 'Von der Idee zur fertigen Raumgestaltung' },
    ],
    faqs: [
      { q: 'Welche Oberflächen können foliert werden?', a: 'Nahezu alle glatten Oberflächen: Glas, Metall, Holz, Kunststoff. Wir beraten Sie zu den Möglichkeiten Ihrer spezifischen Anwendung.' },
      { q: 'Wie lange dauert ein Raumprojekt?', a: 'Je nach Umfang 2-8 Wochen von der Konzeption bis zur Fertigstellung. Für zeitkritische Projekte bieten wir Express-Optionen.' },
      { q: 'Arbeiten Sie mit Innenarchitekten zusammen?', a: 'Ja, wir sind etablierter Produktionspartner für Architektur- und Designbüros und setzen deren Entwürfe präzise um.' },
      { q: 'Gibt es Mustermaterialien?', a: 'Selbstverständlich. Wir senden Ihnen gerne ein Musterpaket mit den für Ihr Projekt relevanten Materialien zu.' },
    ],
  },
  '/markenkommunikation': {
    slug: 'markenkommunikation',
    label: 'Markenkommunikation',
    heroLabel: 'Markenkommunikation',
    heroTitle: 'Großformat, Systeme, Event',
    heroDesc: 'Von der Messewand bis zur Fassadenwerbung – wir produzieren und installieren Ihre Markenkommunikation in jeder Größe.',
    heroCtaLabel: 'Projekt anfragen',
    servicesLabel: 'Leistungen',
    servicesTitle: 'Unsere Kompetenzen',
    projectsLabel: 'Referenzen',
    projectsTitle: 'Ausgewählte Projekte',
    projectsCtaLabel: 'Alle Projekte',
    faqLabel: 'Fragen',
    faqTitle: 'Häufig gefragt',
    ctaLabel: 'Jetzt starten',
    ctaTitle: 'Ihr Kommunikationsprojekt',
    ctaDesc: 'Messe, Event oder Retail – wir realisieren Ihre visuelle Kommunikation in jeder Größenordnung.',
    ctaButtonLabel: 'Kontakt aufnehmen',
    heroImage: images.servicePages['markenkommunikation'],
    services: [
      { title: 'Großformatmedien', desc: 'Banner, Planen, Fassadenwerbung im XXL-Format' },
      { title: 'Werbesysteme', desc: 'Displays, Roll-ups, Messewände und Aufsteller' },
      { title: 'Printmedien', desc: 'Flyer, Broschüren, Kataloge und Geschäftsausstattung' },
      { title: 'Event- & Messegrafik', desc: 'Komplette visuelle Ausstattung für Ihre Events' },
      { title: 'POS-Systeme', desc: 'Point-of-Sale Materialien und Ladenkommunikation' },
    ],
    faqs: [
      { q: 'Welche Druckgrößen sind möglich?', a: 'Nahezu unbegrenzt – von Visitenkarten bis zu Fassadenwerbung über mehrere hundert Quadratmeter. Wir beraten zur optimalen Lösung.' },
      { q: 'Können Sie komplette Messestände liefern?', a: 'Ja, wir bieten Full-Service: Konzept, Grafik, Produktion und Aufbau – alles aus einer Hand.' },
      { q: 'Wie kurzfristig können Sie produzieren?', a: 'Express-Produktion ist möglich. Je nach Umfang können wir auch sehr kurzfristige Termine realisieren.' },
      { q: 'Bieten Sie auch Montageservice an?', a: 'Selbstverständlich. Unsere Montageteams arbeiten deutschlandweit und auch international.' },
    ],
  },
  '/design-konzepte': {
    slug: 'design',
    label: 'Design & Konzeption',
    heroLabel: 'Design & Konzeption',
    heroTitle: 'Leitlinien, die sich umsetzen lassen',
    heroDesc: 'Design mit Produktionsfokus – wir entwickeln Konzepte, die nicht nur gut aussehen, sondern sich auch realisieren lassen.',
    heroCtaLabel: 'Projekt anfragen',
    servicesLabel: 'Leistungen',
    servicesTitle: 'Unsere Kompetenzen',
    projectsLabel: 'Referenzen',
    projectsTitle: 'Ausgewählte Projekte',
    projectsCtaLabel: 'Alle Projekte',
    faqLabel: 'Fragen',
    faqTitle: 'Häufig gefragt',
    ctaLabel: 'Jetzt starten',
    ctaTitle: 'Ihr Designprojekt',
    ctaDesc: 'Konzept, Visualisierung oder komplette Umsetzung – lassen Sie uns über Ihre Anforderungen sprechen.',
    ctaButtonLabel: 'Kontakt aufnehmen',
    heroImage: images.servicePages['design-konzepte'],
    services: [
      { title: 'Designkonzepte', desc: 'Visuelle Ideen und Konzepte für Ihre Projekte' },
      { title: 'Visuelle Leitlinien', desc: 'Styleguides und Designrichtlinien für Konsistenz' },
      { title: 'Produktionsvorbereitung', desc: 'Druckdaten, Plotdaten und technische Dokumentation' },
      { title: 'Ganzheitliche Markenbegleitung', desc: 'Langfristige Designpartnerschaft für Ihre Marke' },
    ],
    faqs: [
      { q: 'Übernehmen Sie auch die Umsetzung?', a: 'Ja, das ist unsere Stärke: Wir denken von Anfang an produktionsorientiert und können nahtlos in die Umsetzung übergehen.' },
      { q: 'Arbeiten Sie auch für Agenturen?', a: 'Selbstverständlich. Wir sind verlässlicher White-Label-Partner für Agenturen, die Produktionskompetenz benötigen.' },
      { q: 'Welche Formate liefern Sie?', a: 'Alle gängigen Formate: Print-PDFs, Plotdaten, Vektorgrafiken, 3D-Renderings – immer abgestimmt auf den Verwendungszweck.' },
      { q: 'Wie läuft die Abstimmung ab?', a: 'Transparent und effizient: Klare Meilensteine, regelmäßige Präsentationen und strukturiertes Feedback.' },
    ],
  },
  '/projektmanagement': {
    slug: 'projektmanagement',
    label: 'Projektmanagement',
    heroLabel: 'Projektmanagement',
    heroTitle: 'Struktur für große Umsetzungen',
    heroDesc: 'Planung, Koordination und Qualitätssicherung für Flotten, Räume und Events – strukturiert und zuverlässig.',
    heroCtaLabel: 'Projekt anfragen',
    servicesLabel: 'Leistungen',
    servicesTitle: 'Unser Vorgehen',
    projectsLabel: 'Referenzen',
    projectsTitle: 'Ausgewählte Projekte',
    projectsCtaLabel: 'Alle Projekte',
    faqLabel: 'Fragen',
    faqTitle: 'Häufig gefragt',
    ctaLabel: 'Jetzt starten',
    ctaTitle: 'Großprojekt geplant?',
    ctaDesc: 'Flotten-Rollout, Messeauftritt oder komplexe Raumgestaltung – wir übernehmen die Koordination.',
    ctaButtonLabel: 'Kontakt aufnehmen',
    heroImage: images.servicePages['projektmanagement'],
    services: [
      { title: 'Planung', desc: 'Strukturierte Projektplanung und Zeitmanagement' },
      { title: 'Koordination', desc: 'Steuerung aller Beteiligten und Gewerke' },
      { title: 'Materialberatung', desc: 'Auswahl optimaler Materialien für Ihr Projekt' },
      { title: 'Produktion', desc: 'Steuerung und Überwachung der Fertigung' },
      { title: 'Montage', desc: 'Professionelle Installation vor Ort' },
      { title: 'Qualitätssicherung', desc: 'Kontrolle und Abnahme aller Leistungen' },
    ],
    faqs: [],
  },
};

function getServiceFields(pathname) {
  const def = servicePageDefs[pathname];
  if (!def) return [];
  const fields = [];
  const slug = def.slug;

  // Hero Section
  if (def.heroImage) {
    fields.push(
      f(`images.service.${slug}.hero`, 'Hero Bild', 'image', 'Hero-Bild', pathname, def.heroImage),
    );
  }
  fields.push(
    f(`service.${slug}.heroLabel`, 'Hero Label', 'text', 'Hero', pathname, def.heroLabel),
    f(`service.${slug}.heroTitle`, 'Hero Überschrift', 'text', 'Hero', pathname, def.heroTitle),
    f(`service.${slug}.heroDesc`, 'Hero Beschreibung', 'textarea', 'Hero', pathname, def.heroDesc),
    f(`service.${slug}.heroCtaLabel`, 'Hero Button', 'text', 'Hero', pathname, def.heroCtaLabel),
  );

  // Services Section
  fields.push(
    f(`service.${slug}.servicesLabel`, 'Leistungen – Label', 'text', 'Leistungen', pathname, def.servicesLabel),
    f(`service.${slug}.servicesTitle`, 'Leistungen – Überschrift', 'text', 'Leistungen', pathname, def.servicesTitle),
  );
  def.services.forEach((s, i) => {
    fields.push(
      f(`service.${slug}.services.${i}.title`, `Leistung ${i + 1} – Titel`, 'text', 'Leistungen', pathname, s.title),
      f(`service.${slug}.services.${i}.desc`, `Leistung ${i + 1} – Beschreibung`, 'text', 'Leistungen', pathname, s.desc),
    );
  });

  // Projects Section
  fields.push(
    f(`service.${slug}.projectsLabel`, 'Projekte – Label', 'text', 'Projekte', pathname, def.projectsLabel),
    f(`service.${slug}.projectsTitle`, 'Projekte – Überschrift', 'text', 'Projekte', pathname, def.projectsTitle),
    f(`service.${slug}.projectsCtaLabel`, 'Projekte – Button', 'text', 'Projekte', pathname, def.projectsCtaLabel),
  );

  // FAQ Section
  if (def.faqs && def.faqs.length > 0) {
    fields.push(
      f(`service.${slug}.faqLabel`, 'FAQ – Label', 'text', 'FAQ', pathname, def.faqLabel),
      f(`service.${slug}.faqTitle`, 'FAQ – Überschrift', 'text', 'FAQ', pathname, def.faqTitle),
    );
    def.faqs.forEach((faq, i) => {
      fields.push(
        f(`service.${slug}.faqs.${i}.q`, `FAQ ${i + 1} – Frage`, 'text', 'FAQ', pathname, faq.q),
        f(`service.${slug}.faqs.${i}.a`, `FAQ ${i + 1} – Antwort`, 'textarea', 'FAQ', pathname, faq.a),
      );
    });
  }

  // CTA Section
  fields.push(
    f(`service.${slug}.ctaLabel`, 'CTA – Label', 'text', 'CTA', pathname, def.ctaLabel),
    f(`service.${slug}.ctaTitle`, 'CTA – Überschrift', 'text', 'CTA', pathname, def.ctaTitle),
    f(`service.${slug}.ctaDesc`, 'CTA – Beschreibung', 'textarea', 'CTA', pathname, def.ctaDesc),
    f(`service.${slug}.ctaButtonLabel`, 'CTA – Button', 'text', 'CTA', pathname, def.ctaButtonLabel),
  );

  return fields;
}

export function getFieldsForPage(pathname) {
  const fields = [];

  const global = [
    f('company.name', 'Firmenname', 'text', 'Global', '*', company.name),
    f('company.legalName', 'Rechtlicher Firmenname', 'text', 'Global', '*', company.legalName || company.name),
    f('company.tagline', 'Tagline', 'text', 'Global', '*', company.tagline),
    f('company.description', 'Beschreibung', 'textarea', 'Global', '*', company.description),
    f('company.phone', 'Telefon', 'text', 'Global', '*', company.phone),
    f('company.email', 'E-Mail', 'text', 'Global', '*', company.email),
    f('company.city', 'Stadt', 'text', 'Global', '*', company.address.city),
  ];

  // ── Homepage ──
  if (pathname === '/') {
    fields.push(
      f('images.hero.src', 'Hero Bild', 'image', 'Hero-Bild', '/', images.hero.src),
      f('hero.headline', 'Hero Überschrift', 'textarea', 'Hero', '/', hero.headline),
      f('hero.subline', 'Hero Untertitel', 'textarea', 'Hero', '/', hero.subline),
      f('hero.ctaPrimary.label', 'Primärer Button', 'text', 'Hero', '/', hero.ctaPrimary.label),
      f('hero.ctaSecondary.label', 'Sekundärer Button', 'text', 'Hero', '/', hero.ctaSecondary.label),
    );
    statistics.forEach((s, i) => {
      fields.push(
        f(`stats.${i}.value`, `Statistik ${i + 1} – Wert`, 'text', 'Statistiken', '/', String(s.value) + (s.suffix || '')),
        f(`stats.${i}.label`, `Statistik ${i + 1} – Label`, 'text', 'Statistiken', '/', s.label),
      );
    });
    /* Trust bar list: allows add/edit/delete */
    fields.push({
      key: 'trustbar.items',
      label: 'Trust-Bar (Liste)',
      type: 'list',
      group: 'Statistiken',
      page: '/',
      default: statistics.map(s => ({ value: `${s.value}${s.suffix || ''}`, label: s.label })),
      schema: [
        { key: 'value', label: 'Wert', placeholder: 'z.B. 500+' },
        { key: 'label', label: 'Label', placeholder: 'z.B. Projekte' },
      ],
    });
    targetAudiences.forEach((a, i) => {
      fields.push(
        f(`audiences.${i}.title`, `Zielgruppe ${i + 1} – Titel`, 'text', 'Zielgruppen', '/', a.title),
        f(`audiences.${i}.focus`, `Zielgruppe ${i + 1} – Fokus`, 'text', 'Zielgruppen', '/', a.focus),
      );
    });
    /* ── Was wir tun (Services) ── */
    fields.push(
      f('services.sectionLabel', 'Obertitel', 'text', 'Was wir tun', '/', 'Leistungen'),
      f('services.sectionTitle', 'Überschrift', 'text', 'Was wir tun', '/', 'Was wir tun.'),
    );
    const defaultServices = [
      { label: 'Mobilität', title: 'Fahrzeuge, die auffallen.', desc: 'Von der Lackschutzfolie bis zum kompletten Flottenbranding — wir realisieren Ihre Fahrzeugprojekte mit Präzision und Premium-Qualität.', features: 'PPF & Lackschutz, Flottenbranding, Teil- & Vollfolierung, Designkonzepte', href: '/mobilitaet', image: '/images/porsche-gt3-cup-race.webp' },
      { label: 'Raum & Architektur', title: 'Räume, die wirken.', desc: 'Wir transformieren Räume in Markenerlebnisse — durch Architekturfolierung, Glasgestaltung und Interior Branding.', features: 'Raumgestaltung, Architekturfolierung, Glas- & Sichtschutzfolien, Interior Branding', href: '/architektur-raum', image: '/images/IMG_5646.webp' },
      { label: 'Markenkommunikation', title: 'Botschaften, die ankommen.', desc: 'Von der Messewand bis zur Fassadenwerbung — wir produzieren und installieren Ihre Markenkommunikation in jeder Größe.', features: 'Großformatmedien, Werbesysteme, Event- & Messegrafik, POS-Systeme', href: '/markenkommunikation', image: '/images/IMG_7190.webp' },
    ];
    defaultServices.forEach((svc, i) => {
      fields.push(
        f(`services.${i}.image`, `Leistung ${i + 1} – Bild`, 'image', 'Was wir tun', '/', svc.image),
        f(`services.${i}.label`, `Leistung ${i + 1} – Kategorie`, 'text', 'Was wir tun', '/', svc.label),
        f(`services.${i}.title`, `Leistung ${i + 1} – Überschrift`, 'text', 'Was wir tun', '/', svc.title),
        f(`services.${i}.desc`, `Leistung ${i + 1} – Beschreibung`, 'textarea', 'Was wir tun', '/', svc.desc),
        f(`services.${i}.features`, `Leistung ${i + 1} – Merkmale (kommagetrennt)`, 'text', 'Was wir tun', '/', svc.features),
        f(`services.${i}.href`, `Leistung ${i + 1} – Link`, 'text', 'Was wir tun', '/', svc.href),
      );
    });

    /* ── Showcase ── */
    fields.push(
      f('homepage.showcase.label', 'Showcase – Obertitel', 'text', 'Showcase', '/', 'Premium Qualität'),
      f('homepage.showcase.title', 'Showcase – Überschrift', 'text', 'Showcase', '/', 'Kompromisslos in jedem Detail.'),
    );

    /* ── Projects ── */
    fields.push(
      f('homepage.projects.label', 'Projekte – Obertitel', 'text', 'Projekte', '/', 'Portfolio'),
      f('homepage.projects.title', 'Projekte – Überschrift', 'text', 'Projekte', '/', 'Ausgewählte Projekte'),
      f('homepage.projects.linkText', 'Projekte – Link-Text', 'text', 'Projekte', '/', 'Alle Projekte'),
    );
    // Featured Projects – editable titles, categories, and images
    const featuredProjectsData = [
      { slug: 'Flottenbranding', category: 'Mobilität', title: 'Flottenbranding' },
      { slug: 'Lackschutz', category: 'Mobilität', title: 'PPF Porsche 911' },
      { slug: 'headquarters-tech-konzern', category: 'Architektur', title: 'Headquarters Tech-Konzern' },
      { slug: 'messestand', category: 'Kommunikation', title: 'Messestand' },
    ];
    featuredProjectsData.forEach((p, i) => {
      fields.push(
        f(`projects.${p.slug}.category`, `Projekt ${i + 1} – Kategorie`, 'text', 'Projektdaten', '/', p.category),
        f(`projects.${p.slug}.title`, `Projekt ${i + 1} – Titel`, 'text', 'Projektdaten', '/', p.title),
        f(`images.projects.${p.slug}.thumbnail`, `Projekt ${i + 1} – Bild`, 'image', 'Projektbilder', '/', ''),
      );
    });

    /* ── Process ── */
    fields.push(
      f('homepage.process.label', 'Prozess – Obertitel', 'text', 'Prozess', '/', 'Ablauf'),
      f('homepage.process.title', 'Prozess – Überschrift', 'text', 'Prozess', '/', 'Unser Prozess'),
    );
    processSteps.forEach((p, i) => {
      fields.push(
        f(`process.${i}.title`, `Schritt ${p.num} – Titel`, 'text', 'Prozess', '/', p.title),
        f(`process.${i}.desc`, `Schritt ${p.num} – Beschreibung`, 'text', 'Prozess', '/', p.desc),
      );
    });

    /* ── Testimonials ── */
    fields.push(
      f('homepage.testimonials.label', 'Bewertungen – Obertitel', 'text', 'Bewertungen', '/', 'Kundenstimmen'),
      f('homepage.testimonials.title', 'Bewertungen – Überschrift', 'text', 'Bewertungen', '/', 'Was unsere Kunden sagen'),
    );
    testimonials.forEach((t, i) => {
      fields.push(
        f(`testimonials.${i}.quote`, `Bewertung ${i + 1} – Zitat`, 'textarea', 'Bewertungen', '/', t.quote),
        f(`testimonials.${i}.author`, `Bewertung ${i + 1} – Autor`, 'text', 'Bewertungen', '/', t.author),
        f(`testimonials.${i}.position`, `Bewertung ${i + 1} – Position`, 'text', 'Bewertungen', '/', t.position),
        f(`testimonials.${i}.company`, `Bewertung ${i + 1} – Firma`, 'text', 'Bewertungen', '/', t.company),
      );
    });

    /* ── FAQ ── */
    const defaultFaqs = [
      { q: 'Was kostet eine Fahrzeugfolierung?', a: 'Die Kosten variieren je nach Fahrzeugtyp und Umfang. Eine Teilfolierung beginnt bei ca. 800 €, eine Vollfolierung ab ca. 2.500 €. Wir erstellen Ihnen gerne ein individuelles Angebot.' },
      { q: 'Wie lange dauert ein typisches Projekt?', a: 'Fahrzeugprojekte dauern in der Regel 3–7 Werktage. Raum- und Architekturprojekte planen wir mit 2–8 Wochen. Express-Optionen sind bei Bedarf verfügbar.' },
      { q: 'Arbeiten Sie auch außerhalb von NRW?', a: 'Ja, unsere mobilen Teams sind europaweit im Einsatz. Wir realisieren Projekte in ganz Deutschland und im angrenzenden Ausland.' },
      { q: 'Bieten Sie auch Designleistungen an?', a: 'Absolut. Von der Konzeptentwicklung über Visualisierungen bis zur produktionsreifen Reinzeichnung — alles aus einer Hand.' },
      { q: 'Wie läuft die Zusammenarbeit ab?', a: 'Nach einem kurzen Briefing erstellen wir ein Konzept und Angebot. Nach Freigabe starten wir mit Produktion und termingerechter Montage. Qualitätskontrolle inklusive.' },
    ];
    fields.push(
      f('homepage.faq.label', 'FAQ – Obertitel', 'text', 'FAQ', '/', 'FAQ'),
      f('homepage.faq.title', 'FAQ – Überschrift', 'text', 'FAQ', '/', 'Häufige Fragen'),
    );
    defaultFaqs.forEach((faq, i) => {
      fields.push(
        f(`homepage.faq.${i}.q`, `FAQ ${i + 1} – Frage`, 'text', 'FAQ', '/', faq.q),
        f(`homepage.faq.${i}.a`, `FAQ ${i + 1} – Antwort`, 'textarea', 'FAQ', '/', faq.a),
      );
    });

    /* ── CTA ── */
    fields.push(
      f('cta.headline', 'CTA Überschrift', 'text', 'CTA', '/', ctaSection.headline),
      f('cta.subline', 'CTA Untertitel', 'textarea', 'CTA', '/', ctaSection.subline),
      f('cta.btnLabel', 'CTA Button-Text', 'text', 'CTA', '/', 'Kontakt aufnehmen'),
    );
  }

  // ── Kontakt-Seite ──
  if (pathname === '/kontakt') {
    fields.push(
      f('kontakt.hero.label', 'Hero – Obertitel', 'text', 'Kontakt Hero', '/kontakt', 'Kontakt'),
      f('kontakt.hero.title', 'Hero – Überschrift', 'text', 'Kontakt Hero', '/kontakt', 'Projekt anfragen'),
      f('kontakt.hero.desc', 'Hero – Beschreibung', 'textarea', 'Kontakt Hero', '/kontakt', 'Kurze Infos reichen – wir melden uns mit Rückfragen oder einem konkreten Vorschlag.'),
      f('kontakt.form.nameLabel', 'Formular – Name Label', 'text', 'Kontakt Formular', '/kontakt', 'Name *'),
      f('kontakt.form.namePlaceholder', 'Formular – Name Placeholder', 'text', 'Kontakt Formular', '/kontakt', 'Ihr Name'),
      f('kontakt.form.emailLabel', 'Formular – E-Mail Label', 'text', 'Kontakt Formular', '/kontakt', 'E-Mail *'),
      f('kontakt.form.emailPlaceholder', 'Formular – E-Mail Placeholder', 'text', 'Kontakt Formular', '/kontakt', 'ihre@email.de'),
      f('kontakt.form.phoneLabel', 'Formular – Telefon Label', 'text', 'Kontakt Formular', '/kontakt', 'Telefon'),
      f('kontakt.form.phonePlaceholder', 'Formular – Telefon Placeholder', 'text', 'Kontakt Formular', '/kontakt', '+49 ...'),
      f('kontakt.form.serviceLabel', 'Formular – Leistung Label', 'text', 'Kontakt Formular', '/kontakt', 'Welche Leistung?'),
      f('kontakt.form.servicePlaceholder', 'Formular – Leistung Placeholder', 'text', 'Kontakt Formular', '/kontakt', 'Bitte wählen...'),
      f('kontakt.form.messageLabel', 'Formular – Nachricht Label', 'text', 'Kontakt Formular', '/kontakt', 'Ihre Nachricht *'),
      f('kontakt.form.messagePlaceholder', 'Formular – Nachricht Placeholder', 'text', 'Kontakt Formular', '/kontakt', 'Beschreiben Sie kurz Ihr Projekt oder Ihre Anfrage...'),
      f('kontakt.form.submitLabel', 'Formular – Submit Button', 'text', 'Kontakt Formular', '/kontakt', 'Anfrage senden'),
      f('kontakt.form.submittingLabel', 'Formular – Submitting Text', 'text', 'Kontakt Formular', '/kontakt', 'Wird gesendet...'),
      f('kontakt.sidebar.title', 'Sidebar – Überschrift', 'text', 'Kontakt Sidebar', '/kontakt', 'Direkt erreichen'),
      f('kontakt.sidebar.email', 'Sidebar – E-Mail', 'text', 'Kontakt Sidebar', '/kontakt', 'info@visuworks.de'),
      f('kontakt.sidebar.phone', 'Sidebar – Telefon', 'text', 'Kontakt Sidebar', '/kontakt', '+49 211 123 456 78'),
      f('kontakt.sidebar.location', 'Sidebar – Standort', 'text', 'Kontakt Sidebar', '/kontakt', 'Düsseldorf'),
      f('kontakt.sidebar.footer', 'Sidebar – Footer-Text', 'text', 'Kontakt Sidebar', '/kontakt', 'Projekte europaweit · Standort Düsseldorf'),
      f('kontakt.sidebar.cta', 'Sidebar – CTA Button Text', 'text', 'Kontakt Sidebar', '/kontakt', 'Projekt anfragen'),
      f('kontakt.sidebar.ctaUrl', 'Sidebar – CTA Button URL', 'text', 'Kontakt Sidebar', '/kontakt', '/kontakt#form'),
    );
  }

  // ── Danke-Seite ──
  if (pathname === '/danke') {
    fields.push(
      f('danke.title', 'Überschrift', 'text', 'Danke', '/danke', 'Vielen Dank!'),
      f('danke.subtitle', 'Untertitel', 'text', 'Danke', '/danke', 'Ihre Projektanfrage ist bei uns eingegangen.'),
      f('danke.message', 'Nachricht', 'textarea', 'Danke', '/danke', 'Wir melden uns in der Regel innerhalb von 24 Stunden bei Ihnen mit Rückfragen oder einem konkreten Vorschlag.'),
      f('danke.homeBtn', 'Startseite-Button', 'text', 'Danke', '/danke', 'Zur Startseite'),
      f('danke.projekteBtn', 'Projekte-Button', 'text', 'Danke', '/danke', 'Projekte ansehen'),
    );
  }

  // ── Impressum-Seite ──
  if (pathname === '/impressum') {
    fields.push(
      f('impressum.label', 'Obertitel', 'text', 'Impressum Header', '/impressum', 'Rechtliches'),
      f('impressum.title', 'Überschrift', 'text', 'Impressum Header', '/impressum', 'Impressum'),
      f('impressum.subtitle', 'Untertitel', 'text', 'Impressum Header', '/impressum', 'gemäß § 5 TMG und § 18 Abs. 2 MStV'),
      f('impressum.tocLabel', 'Inhaltsverzeichnis Label', 'text', 'Impressum Header', '/impressum', 'Inhaltsverzeichnis'),
      f('impressum.stand', 'Stand Datum', 'text', 'Impressum Header', '/impressum', 'Stand: März 2026'),
      f('impressum.weitereTexte', 'Weitere Rechtstexte Label', 'text', 'Impressum Header', '/impressum', 'Weitere Rechtstexte:'),
      // Firmendaten
      f('impressum.firmenname', 'Firmenname', 'text', 'Anbieter', '/impressum', 'Visuworks visual work labs GmbH'),
      f('impressum.strasse', 'Straße', 'text', 'Anbieter', '/impressum', 'Verbindungsstraße 19c'),
      f('impressum.plz', 'PLZ', 'text', 'Anbieter', '/impressum', '40723'),
      f('impressum.ort', 'Ort', 'text', 'Anbieter', '/impressum', 'Hilden'),
      f('impressum.bundesland', 'Bundesland', 'text', 'Anbieter', '/impressum', 'Nordrhein-Westfalen'),
      f('impressum.land', 'Land', 'text', 'Anbieter', '/impressum', 'Deutschland'),
      f('impressum.vertreter', 'Vertreter Name', 'text', 'Vertreten durch', '/impressum', 'Daniel Zura'),
      f('impressum.vertreterRolle', 'Vertreter Rolle', 'text', 'Vertreten durch', '/impressum', 'Gesellschafter / Geschäftsführer'),
      f('impressum.telefon', 'Telefon', 'text', 'Kontakt', '/impressum', '+49 (0)151 72615378'),
      f('impressum.email', 'E-Mail', 'text', 'Kontakt', '/impressum', 'info@visuworks.de'),
      f('impressum.website', 'Website', 'text', 'Kontakt', '/impressum', 'www.visuworks.de'),
      f('impressum.registergericht', 'Registergericht', 'text', 'Registereintrag', '/impressum', 'Amtsgericht Düsseldorf'),
      f('impressum.registernummer', 'Registernummer', 'text', 'Registereintrag', '/impressum', 'HRB 96931'),
      f('impressum.ustid', 'USt-ID', 'text', 'Umsatzsteuer-ID', '/impressum', 'DE353393855'),
      f('impressum.instagram', 'Instagram URL', 'text', 'Social Media', '/impressum', 'https://www.instagram.com/visualworklabs/'),
      f('impressum.tiktok', 'TikTok URL', 'text', 'Social Media', '/impressum', 'https://www.tiktok.com/@visuworks'),
    );
  }

  // ── Datenschutz-Seite ──
  if (pathname === '/datenschutz') {
    fields.push(
      f('datenschutz.label', 'Obertitel', 'text', 'Datenschutz Header', '/datenschutz', 'Rechtliches'),
      f('datenschutz.title', 'Überschrift', 'text', 'Datenschutz Header', '/datenschutz', 'Datenschutzerklärung'),
      f('datenschutz.tocLabel', 'Inhaltsverzeichnis Label', 'text', 'Datenschutz Header', '/datenschutz', 'Inhaltsverzeichnis'),
      f('datenschutz.stand', 'Stand Datum', 'text', 'Datenschutz Header', '/datenschutz', 'Stand: März 2026'),
      f('datenschutz.weitereTexte', 'Weitere Rechtstexte Label', 'text', 'Datenschutz Header', '/datenschutz', 'Weitere Rechtstexte:'),
      // Firmendaten für Verantwortlicher
      f('datenschutz.firmenname', 'Firmenname', 'text', 'Verantwortlicher', '/datenschutz', 'Visuworks visual work labs GmbH'),
      f('datenschutz.strasse', 'Straße', 'text', 'Verantwortlicher', '/datenschutz', 'Verbindungsstraße 19c'),
      f('datenschutz.plz', 'PLZ', 'text', 'Verantwortlicher', '/datenschutz', '40723'),
      f('datenschutz.ort', 'Ort', 'text', 'Verantwortlicher', '/datenschutz', 'Hilden'),
      f('datenschutz.land', 'Land', 'text', 'Verantwortlicher', '/datenschutz', 'Deutschland'),
      f('datenschutz.geschaeftsfuehrer', 'Geschäftsführer', 'text', 'Verantwortlicher', '/datenschutz', 'Daniel Zura'),
      f('datenschutz.register', 'Handelsregister', 'text', 'Verantwortlicher', '/datenschutz', 'AG Düsseldorf, HRB 96931'),
      f('datenschutz.telefon', 'Telefon', 'text', 'Verantwortlicher', '/datenschutz', '+49 (0)151 72615378'),
      f('datenschutz.datenschutzEmail', 'Datenschutz E-Mail', 'text', 'Verantwortlicher', '/datenschutz', 'datenschutz@visuworks.de'),
    );
  }

  // ── AGB (B2C) Seite ──
  if (pathname === '/agb') {
    fields.push(
      f('agb.label', 'Obertitel', 'text', 'AGB', '/agb', 'Rechtliches'),
      f('agb.title', 'Überschrift', 'text', 'AGB', '/agb', 'Allgemeine Geschäftsbedingungen (B2C)'),
      f('agb.subtitle', 'Untertitel', 'text', 'AGB', '/agb', 'Gültig für Verbraucher im Sinne des §13 BGB.'),
      f('agb.tocLabel', 'Inhaltsverzeichnis Label', 'text', 'AGB', '/agb', 'Inhaltsverzeichnis'),
      f('agb.stand', 'Stand Datum', 'text', 'AGB', '/agb', 'Stand: März 2026'),
      f('agb.weitereTexte', 'Weitere Rechtstexte Label', 'text', 'AGB', '/agb', 'Weitere Rechtstexte:'),
    );
  }

  // ── AGB B2B Seite ──
  if (pathname === '/agb-b2b') {
    fields.push(
      f('agbb2b.label', 'Obertitel', 'text', 'AGB B2B', '/agb-b2b', 'Rechtliches'),
      f('agbb2b.title', 'Überschrift', 'text', 'AGB B2B', '/agb-b2b', 'Allgemeine Geschäftsbedingungen für Unternehmer (B2B)'),
      f('agbb2b.subtitle', 'Untertitel', 'text', 'AGB B2B', '/agb-b2b', 'Diese AGB gelten ausschließlich gegenüber Unternehmern im Sinne des §14 BGB.'),
      f('agbb2b.tocLabel', 'Inhaltsverzeichnis Label', 'text', 'AGB B2B', '/agb-b2b', 'Inhaltsverzeichnis'),
      f('agbb2b.stand', 'Stand Datum', 'text', 'AGB B2B', '/agb-b2b', 'Stand: März 2026'),
      f('agbb2b.weitereTexte', 'Weitere Rechtstexte Label', 'text', 'AGB B2B', '/agb-b2b', 'Weitere Rechtstexte:'),
    );
  }

  // ── Service Pages ──
  const serviceFields = getServiceFields(pathname);
  if (serviceFields.length > 0) {
    fields.push(...serviceFields);
  }

  // ── Projekte-Übersicht ──
  if (pathname === '/projekte') {
    fields.push(
      f('projekte.heroLabel', 'Hero – Obertitel', 'text', 'Hero', '/projekte', 'Portfolio'),
      f('projekte.heroTitle', 'Hero Überschrift', 'text', 'Hero', '/projekte', 'Projekte & Referenzen'),
      f('projekte.heroSubline', 'Hero Untertitel', 'text', 'Hero', '/projekte', 'Kuratiert. Präzise. Umgesetzt.'),
      f('projekte.ctaLabel', 'CTA – Obertitel', 'text', 'CTA', '/projekte', 'Jetzt starten'),
      f('projekte.ctaTitle', 'CTA – Überschrift', 'text', 'CTA', '/projekte', 'Ihr Projekt als nächstes?'),
      f('projekte.ctaDesc', 'CTA – Beschreibung', 'textarea', 'CTA', '/projekte', 'Lassen Sie uns über Ihre Anforderungen sprechen – unverbindlich und persönlich.'),
      f('projekte.ctaButtonLabel', 'CTA – Button 1', 'text', 'CTA', '/projekte', 'Projekt besprechen'),
      f('projekte.ctaButton2Label', 'CTA – Button 2', 'text', 'CTA', '/projekte', 'Angebot anfordern'),
    );
    projects.forEach((p) => {
      const img = images.projects[p.slug];
      fields.push(
        f(`projects.${p.slug}.title`, `${p.title.substring(0, 22)} – Titel`, 'text', 'Projekte', '/projekte', p.title),
        f(`projects.${p.slug}.subtitle`, `${p.title.substring(0, 22)} – Untertitel`, 'text', 'Projekte', '/projekte', p.subtitle),
      );
      if (img?.thumbnail) {
        fields.push(
          f(`images.projects.${p.slug}.thumbnail`, `${p.title.substring(0, 22)} – Bild`, 'image', 'Projektbilder', '/projekte', img.thumbnail),
        );
      }
    });
  }

  // ── Team-Seite ──
  if (pathname === '/team') {
    fields.push(
      f('team.heroLabel', 'Hero – Obertitel', 'text', 'Hero', '/team', 'Über uns'),
      f('team.heroTitle', 'Hero – Überschrift', 'text', 'Hero', '/team', 'Das Team hinter VISUWORKS'),
      f('team.heroDesc', 'Hero – Beschreibung', 'textarea', 'Hero', '/team', 'Experten aus Design, Produktion und Projektmanagement – vereint in der Leidenschaft für visuelle Exzellenz.'),
      f('team.valuesLabel', 'Werte – Obertitel', 'text', 'Werte', '/team', 'Werte'),
      f('team.valuesTitle', 'Werte – Überschrift', 'text', 'Werte', '/team', 'Wofür wir stehen'),
      f('team.companyLabel', 'Unternehmen – Obertitel', 'text', 'Unternehmen', '/team', 'Unternehmen'),
      f('team.companyTitle', 'Unternehmen – Überschrift', 'text', 'Unternehmen', '/team', '15 Jahre Erfahrung im Premium-Segment'),
      f('team.companyText1', 'Unternehmen – Text 1', 'textarea', 'Unternehmen', '/team', 'VISUWORKS wurde 2010 in Düsseldorf gegründet mit dem Ziel, visuelle Markenlösungen auf höchstem Niveau zu realisieren. Was als kleine Werkstatt begann, ist heute ein Full-Service-Partner für Unternehmen in ganz Europa.'),
      f('team.companyText2', 'Unternehmen – Text 2', 'textarea', 'Unternehmen', '/team', 'Unser Standort in Düsseldorf ist das Zentrum unserer Aktivitäten, aber unsere Projekte führen uns durch ganz Europa – von der kleinen Fahrzeugfolierung bis zum internationalen Flotten-Rollout.'),
      f('team.companyImageAlt', 'Unternehmen – Bild-Alt', 'text', 'Unternehmen', '/team', 'Unternehmensstandort Düsseldorf'),
      f('team.ctaTitle', 'CTA – Überschrift', 'text', 'CTA', '/team', 'Zusammenarbeit starten?'),
      f('team.ctaDesc', 'CTA – Beschreibung', 'textarea', 'CTA', '/team', 'Lernen Sie uns kennen – wir freuen uns auf Ihr Projekt.'),
      f('team.ctaButtonLabel', 'CTA – Button 1', 'text', 'CTA', '/team', 'Kontakt aufnehmen'),
      f('team.ctaButton2Label', 'CTA – Button 2', 'text', 'CTA', '/team', 'Projekte ansehen'),
    );
  }

  // ── 404-Seite ──
  if (pathname === '/404') {
    fields.push(
      f('notfound.title', 'Überschrift', 'text', '404', '/404', 'Seite nicht gefunden'),
      f('notfound.message', 'Nachricht', 'textarea', '404', '/404', 'Die gesuchte Seite existiert leider nicht oder wurde verschoben. Kehren Sie zur Startseite zurück oder kontaktieren Sie uns.'),
      f('notfound.homeButton', 'Startseite-Button', 'text', '404', '/404', 'Zur Startseite'),
      f('notfound.backButton', 'Zurück-Button', 'text', '404', '/404', 'Zurück'),
      f('notfound.linksLabel', 'Links – Label', 'text', '404', '/404', 'Beliebte Seiten:'),
      f('notfound.link1', 'Link 1', 'text', '404', '/404', 'Projekte'),
      f('notfound.link2', 'Link 2', 'text', '404', '/404', 'Mobilität'),
      f('notfound.link3', 'Link 3', 'text', '404', '/404', 'Kontakt'),
    );
  }

  // ── Einzelnes Projekt ──
  const projectMatch = pathname.match(/^\/projekte\/(.+)$/);
  if (projectMatch) {
    const slug = decodeURIComponent(projectMatch[1]);
    const p = projects.find((x) => x.slug === slug);
    if (p) {
      const img = images.projects[slug];
      // Project image
      if (img?.thumbnail) {
        fields.push(
          f(`images.projects.${slug}.thumbnail`, 'Hauptbild', 'image', 'Projekt-Bilder', pathname, img.thumbnail),
        );
      }
      // Gallery images
      if (img?.gallery?.length > 0) {
        img.gallery.forEach((src, i) => {
          fields.push(
            f(`images.projects.${slug}.gallery.${i}`, `Galerie-Bild ${i + 1}`, 'image', 'Projekt-Galerie', pathname, src),
          );
        });
      }
      // Text fields
      fields.push(
        f(`projects.${slug}.title`, 'Projekttitel', 'text', 'Projekt', pathname, p.title),
        f(`projects.${slug}.subtitle`, 'Untertitel', 'text', 'Projekt', pathname, p.subtitle),
        f(`projects.${slug}.category`, 'Kategorie', 'text', 'Projekt', pathname, p.category),
        f(`projects.${slug}.client`, 'Auftraggeber', 'text', 'Projekt-Details', pathname, p.client),
        f(`projects.${slug}.scope`, 'Umfang', 'text', 'Projekt-Details', pathname, p.scope),
        f(`projects.${slug}.location`, 'Standort', 'text', 'Projekt-Details', pathname, p.location),
        f(`projects.${slug}.year`, 'Jahr', 'text', 'Projekt-Details', pathname, p.year),
        f(`projects.${slug}.shortDesc`, 'Kurzbeschreibung', 'textarea', 'Projekt-Texte', pathname, p.shortDesc),
        f(`projects.${slug}.challenge`, 'Herausforderung', 'textarea', 'Projekt-Texte', pathname, p.challenge),
        f(`projects.${slug}.solution`, 'Lösung', 'textarea', 'Projekt-Texte', pathname, p.solution),
        f(`projects.${slug}.implementation`, 'Umsetzung', 'textarea', 'Projekt-Texte', pathname, p.implementation),
        f(`projects.${slug}.result`, 'Ergebnis', 'textarea', 'Projekt-Texte', pathname, p.result),
      );
      // Case Study Labels (global for all project pages)
      if (!fields.some(f => f.key === 'casestudy.backLink')) {
        fields.push(
          f('casestudy.backLink', 'Zurück-Link Text', 'text', 'Case Study Labels', pathname, 'Zurück zu Projekte'),
          f('casestudy.labels.client', 'Label – Kunde', 'text', 'Case Study Labels', pathname, 'Kunde'),
          f('casestudy.labels.scope', 'Label – Umfang', 'text', 'Case Study Labels', pathname, 'Umfang'),
          f('casestudy.labels.location', 'Label – Standort', 'text', 'Case Study Labels', pathname, 'Standort'),
          f('casestudy.labels.year', 'Label – Jahr', 'text', 'Case Study Labels', pathname, 'Jahr'),
          f('casestudy.challenge.label', 'Herausforderung – Label', 'text', 'Case Study Labels', pathname, 'Herausforderung'),
          f('casestudy.challenge.title', 'Herausforderung – Titel', 'text', 'Case Study Labels', pathname, 'Die Aufgabe'),
          f('casestudy.solution.label', 'Lösung – Label', 'text', 'Case Study Labels', pathname, 'Lösung'),
          f('casestudy.solution.title', 'Lösung – Titel', 'text', 'Case Study Labels', pathname, 'Unser Ansatz'),
          f('casestudy.implementation.label', 'Umsetzung – Label', 'text', 'Case Study Labels', pathname, 'Umsetzung'),
          f('casestudy.implementation.title', 'Umsetzung – Titel', 'text', 'Case Study Labels', pathname, 'Die Realisierung'),
          f('casestudy.gallery.label', 'Galerie – Label', 'text', 'Case Study Labels', pathname, 'Impressionen'),
          f('casestudy.gallery.title', 'Galerie – Titel', 'text', 'Case Study Labels', pathname, 'Galerie'),
          f('casestudy.result.label', 'Ergebnis – Label', 'text', 'Case Study Labels', pathname, 'Ergebnis'),
          f('casestudy.result.title', 'Ergebnis – Titel', 'text', 'Case Study Labels', pathname, 'Das Resultat'),
          f('casestudy.cta.title', 'CTA – Überschrift', 'text', 'Case Study CTA', pathname, 'Ähnliches Projekt geplant?'),
          f('casestudy.cta.desc', 'CTA – Beschreibung', 'textarea', 'Case Study CTA', pathname, 'Lassen Sie uns über Ihre Anforderungen sprechen – unverbindlich und persönlich.'),
          f('casestudy.cta.buttonLabel', 'CTA – Button 1', 'text', 'Case Study CTA', pathname, 'Projekt besprechen'),
          f('casestudy.cta.button2Label', 'CTA – Button 2', 'text', 'Case Study CTA', pathname, 'Weitere Projekte'),
        );
      }
    }
  }

  // ── Prozess-Seiten (/prozess/:slug) ──
  if (pathname.startsWith('/prozess/')) {
    const processSteps = ['analyse', 'design', 'produktion', 'umsetzung', 'qualitaetssicherung'];
    fields.push(
      f('process.breadcrumb.home', 'Breadcrumb – Start', 'text', 'Navigation', pathname, 'Start'),
      f('process.breadcrumb.process', 'Breadcrumb – Prozess', 'text', 'Navigation', pathname, 'Unser Prozess'),
      f('process.breadcrumb.step', 'Breadcrumb – Schritt', 'text', 'Navigation', pathname, 'Schritt'),
      f('process.stepLabel', 'Schritt-Label', 'text', 'Labels', pathname, 'Schritt'),
      f('process.stepOf', 'Schritt von', 'text', 'Labels', pathname, 'von'),
      f('process.durationLabel', 'Dauer-Label', 'text', 'Labels', pathname, 'Typische Dauer'),
      f('process.deliverablesLabel', 'Ergebnisse – Label', 'text', 'Labels', pathname, 'Ergebnisse'),
      f('process.deliverablesTitle', 'Ergebnisse – Titel', 'text', 'Labels', pathname, 'Was Sie in diesem Schritt erhalten'),
      f('process.ctaButton', 'CTA – Button', 'text', 'CTA', pathname, 'Projekt starten'),
      f('process.cta.title', 'CTA – Überschrift', 'text', 'CTA', pathname, 'Bereit für Ihr Projekt?'),
      f('process.cta.desc', 'CTA – Beschreibung', 'textarea', 'CTA', pathname, 'Lassen Sie uns gemeinsam den ersten Schritt machen – unverbindlich und persönlich.'),
      f('process.cta.buttonLabel', 'CTA – Button 1', 'text', 'CTA', pathname, 'Projekt besprechen'),
      f('process.cta.button2Label', 'CTA – Button 2', 'text', 'CTA', pathname, 'Referenzen ansehen'),
    );
  }

  // ── SubService-Seiten (/leistung/:slug) ──
  if (pathname.startsWith('/leistung/')) {
    fields.push(
      f('subservice.breadcrumb.home', 'Breadcrumb – Start', 'text', 'Navigation', pathname, 'Start'),
      f('subservice.ctaButton', 'CTA – Button Hero', 'text', 'Buttons', pathname, 'Projekt anfragen'),
      f('subservice.applicationsLabel', 'Anwendungen – Label', 'text', 'Labels', pathname, 'Einsatzbereiche'),
      f('subservice.applicationsTitle', 'Anwendungen – Titel', 'text', 'Labels', pathname, 'Typische Anwendungen'),
      f('subservice.cta.buttonLabel', 'CTA – Button 1', 'text', 'CTA', pathname, 'Unverbindlich anfragen'),
      f('subservice.cta.button2Label', 'CTA – Button 2', 'text', 'CTA', pathname, 'Referenzen ansehen'),
    );
  }

  return [...global, ...fields];
}
